export default {
  by: "(Photo by "
};
